module.exports = __webpack_public_path__ + "img/3.090be40d.png";